import type { RelatedKeywordTip, SearchResponseBody } from '@/@types/search'
import { RELATED_KEYWORD_TIP, SEARCH } from '@/constants/api'
import type { AxiosRequestConfig } from 'axios'
import { get, post } from '../request'

export async function search(keyword: string) {
	return post(SEARCH, {
		keywords: keyword,
		limit: 10,
	}).then((res) => res.data as SearchResponseBody)
}

export async function getKeywordTip(keyword: string, config?: AxiosRequestConfig) {
	return get(RELATED_KEYWORD_TIP, {
		params: {
			keyword,
			limit: 20,
		},
		...config,
	}).then((res) => res.data.data as RelatedKeywordTip[])
}
